import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f44fe3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user_responses"
}
const _hoisted_2 = { class: "user_responses__view" }
const _hoisted_3 = { class: "user_responses__container" }
const _hoisted_4 = { class: "user_responses__header" }
const _hoisted_5 = { class: "user_responses__time" }
const _hoisted_6 = { class: "user_responses__dots" }
const _hoisted_7 = { class: "feedback-header" }
const _hoisted_8 = { class: "question-block" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = { class: "user_responses__footer" }
const _hoisted_11 = { class: "user_responses__dots user_responses__dots--mobile" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dot = _resolveComponent("Dot")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_ctx.responseQuestion?.questions)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, "Tempo usado: " + _toDisplayString(_ctx.timeElapsed), 1),
              _createElementVNode("button", {
                class: "btn--back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, "x")
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseQuestion.questions, (dot, index) => {
                return (_openBlock(), _createBlock(_component_Dot, {
                  key: dot.id,
                  index: index,
                  "is-correct": _ctx.isCorrectQuestion(index),
                  "is-incorrect": _ctx.isIncorrectQuestion(index),
                  "is-correction": _ctx.isCorrectionQuestion(index),
                  "is-unanswered": _ctx.isUnansweredQuestion(index),
                  "is-current": index === _ctx.currentIndex,
                  onSelect: _ctx.goToQuestion
                }, null, 8, ["index", "is-correct", "is-incorrect", "is-correction", "is-unanswered", "is-current", "onSelect"]))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["user_responses__feedback-box", {
            correct: _ctx.isCorrectQuestion(_ctx.currentIndex),
            incorrect: _ctx.isIncorrectQuestion(_ctx.currentIndex),
            correction: _ctx.isCorrectionQuestion(_ctx.currentIndex),
            unanswered: _ctx.isUnansweredQuestion(_ctx.currentIndex)
          }])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: _normalizeClass(["feedback-icon", {
                correct: _ctx.isCorrectQuestion(_ctx.currentIndex),
                incorrect: _ctx.isIncorrectQuestion(_ctx.currentIndex),
                correction: _ctx.isCorrectionQuestion(_ctx.currentIndex),
                unanswered: _ctx.isUnansweredQuestion(_ctx.currentIndex)
              }])
                }, null, 2),
                _createElementVNode("strong", null, _toDisplayString(_ctx.feedbackMessage), 1)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_TUIViewer, {
                "model-value": _ctx.currentQuestion.description,
                class: "question"
              }, null, 8, ["model-value"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentQuestion.alternatives, (alternative) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: alternative.id,
                  class: _normalizeClass(["option", {
              correct: _ctx.isCorrectAlternative(alternative),
              incorrect: _ctx.isIncorrectAlternative(alternative)
            }])
                }, [
                  _createElementVNode("input", {
                    type: "radio",
                    disabled: "",
                    checked: _ctx.isAlternativeSelected(alternative),
                    class: _normalizeClass({
                correct: _ctx.isCorrectAlternative(alternative),
                incorrect: _ctx.isIncorrectAlternative(alternative)
              })
                  }, null, 10, _hoisted_9),
                  _createVNode(_component_TUIViewer, {
                    "model-value": alternative.description
                  }, null, 8, ["model-value"])
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("footer", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseQuestion.questions, (dot, index) => {
              return (_openBlock(), _createBlock(_component_Dot, {
                key: dot.id,
                index: index,
                "is-correct": _ctx.isCorrectQuestion(index),
                "is-incorrect": _ctx.isIncorrectQuestion(index),
                "is-correction": _ctx.isCorrectionQuestion(index),
                "is-unanswered": _ctx.isUnansweredQuestion(index),
                "is-current": index === _ctx.currentIndex,
                onSelect: _ctx.goToQuestion
              }, null, 8, ["index", "is-correct", "is-incorrect", "is-correction", "is-unanswered", "is-current", "onSelect"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              disabled: _ctx.currentIndex === 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousQuestion && _ctx.previousQuestion(...args)))
            }, " Pergunta anterior ", 8, _hoisted_13),
            _createElementVNode("button", {
              disabled: _ctx.currentIndex >= _ctx.responseQuestion.questions.length - 1,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextQuestion && _ctx.nextQuestion(...args)))
            }, " Próxima pergunta ", 8, _hoisted_14)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}